import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { interval, Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterModule, Router } from '@angular/router';
import { TOKEN_ADDRESS_MAP, TOKEN_DECIMALS_MAP, CHAIN_MAP } from '../swap/swap.component';
import { environment } from '../../environments/environment';
import { BrowserProvider, Contract } from 'ethers';
import { ChangeDetectorRef } from '@angular/core';
import { SwapApiService } from '../services/swap-api.service';
import { NativeTokenPriceService } from '../services/native-token-price.service';
import { WalletConnectorService } from '../services/wallet-connector.service';
import { ActivatedRoute } from '@angular/router';
import { SettingsComponent } from '../settings/settings.component';
import { WalletService } from '../services/wallet.service';
import { NgZone } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BlurOnClickDirective } from '../directives/blur-on-click.directive';
import { SwapMarketViewerComponent } from './swap-market-viewer.component';
import { SwapGasTrendViewerComponent } from './swap-gas-trend-viewer.component';
import { TokenPriceAlertViewerComponent } from '../token-price-alert-viewer/token-price-alert-viewer.component';
import { GasPriceAlertViewerComponent } from '../gas-price-alert-viewer/gas-price-alert-viewer.component';
import { AlertService } from '../services/alert.service';
import { NotificationService } from '../services/notification.service';
import { ethers } from 'ethers';
import { PriceService } from '../services/price.service';
import { SwiperStandaloneComponent } from '../swiper/swiper-standalone.component';
import { MockAlertSwiperComponent } from '../swiper/mock-alert-swiper.component';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { TokenSelectorComponent } from '../token-selector/token-selector.component';
export interface Alert {
  id: string; // ✅ nouveau champ unique
  chainId: number; 
  alertType: string;
  threshold: number;
  trigger: string;
  active: boolean; // Ajouté pour gérer l'état actif/inactif
  condition?: 'Supérieur à' | 'Inférieur à'; // si utilisée dans le code
  tokenIn?: string;
  tokenOut?: string;
  triggered?: boolean; // ✅ Nouveau champ
  maxGasFee: number | null;
  token?: string;
  tokenA?: string;
  tokenB?: string;
  amountIn?: number;
  conditionMode?: 'AND' | 'OR'; // ✅ corrige ic
  liveQuote?: number | null;
  wallet?: string;
  fcmToken?: string;
  liveGasFee?: number | null;
  currentGasFee?: number | null;
  initialAmountOut?: number | null;
  initialGasFee?: number | null;
  createdAt?: string;       // 🕒 format ISO ou UTC
  ttlMinutes?: number;      // ⏳ durée de vie en minutes
  isExpanded?: boolean; // 👈 optionnel
}


type TokenPriceAlertInput = {
  alertType: string;
  amountIn: number;
  tokenIn: string;
  tokenOut: string;
  threshold: number;
  conditionMode: 'AND' | 'OR';
  maxGasFee?: number;
  liveQuote?: number;
  chainId?: number;
  triggered?: boolean;
  active: boolean;
  currentGasFee?: number;
};
export async function disconnectWallet(this: any, forceKill = true): Promise<void> {
  try {
  
    /* ----------------------------------------------------------------
     * 1️⃣  Réinitialiser l’état du composant
     * ---------------------------------------------------------------- */
    this.takerAddress = null;
    this.provider = null;
    this.quote = null;
    this.signature = null;
    this.session = null;          // ← ajoute

    /* ----------------------------------------------------------------
     * 2️⃣  Purger le stockage local
     * ---------------------------------------------------------------- */
    localStorage.removeItem('wallet');
    localStorage.removeItem('walletconnect');
    localStorage.removeItem('walletconnect_session');
    localStorage.removeItem('subscription');
    localStorage.removeItem('wc_session_id');   // ← ajoute
    sessionStorage.removeItem('WC_DEFAULT_SESSION');

    /* ----------------------------------------------------------------
     * 3️⃣  Déconnecter WalletConnect v2 (mobile & desktop)
     * ---------------------------------------------------------------- */
    const wc: any = (window as any).walletConnectProvider;
    if (wc) {
      try {
        wc.removeAllListeners?.();

        if (typeof wc.disconnect === 'function') {
          await wc.disconnect(forceKill);
        } else if (typeof wc.close === 'function') {
          await wc.close();
        }

        wc.connector?.killSession?.();
      } catch (err) {
        console.warn('[disconnectWallet] WC disconnect error', err);
      }
    }
    delete (window as any).walletConnectProvider; // ← garantit qu’on repart de zéro

    /* ----------------------------------------------------------------
     * 4️⃣  Déconnecter l’extension MetaMask (desktop)
     * ---------------------------------------------------------------- */
    const eth: any = (window as any).ethereum;
    if (eth) {
      eth.removeAllListeners?.();
      if (typeof eth.disconnect === 'function') {
        try {
          await eth.disconnect();
        } catch {/* certaines extensions n’implémentent pas .disconnect() */ }
      }
    }

    /* ----------------------------------------------------------------
     * 5️⃣  (Optionnel) notifier ton backend de supprimer la session
     * ---------------------------------------------------------------- */
    const storedSessionId = localStorage.getItem('wc_session_id');
    if (storedSessionId) {
      fetch(`https://walletconnect-api.vercel.app/api/session?sessionId=${storedSessionId}`, {
        method: 'DELETE'
      }).catch(() => {/* silencieux */ });
    }
    this.chainId = null;
    this.chainInfo = null;
    /* ----------------------------------------------------------------
     * 6️⃣  Feedback utilisateur
     * ---------------------------------------------------------------- */
    console.log('[disconnectWallet] fully disconnected');
    const msg = await firstValueFrom(this.translate.get('WALLET_DISCONNECTED'));

    alert(msg);


  } catch (error) {
    console.error('[disconnectWallet] error', error);
    const fallback = await firstValueFrom(this.translate.get('WALLET_DISCONNECT_ERROR'));
    alert(fallback);
  }
}



export function formatTokenAmount(value: number): string {
  if (value === 0) return '0';
  if (value >= 1) return value.toFixed(4).replace(/\.?0+$/, '');
  if (value >= 0.01) return value.toFixed(5).replace(/\.?0+$/, '');
  if (value >= 0.000001) return value.toFixed(7).replace(/\.?0+$/, '');
  return value.toExponential(2); // ex: 1.23e-6
}






@Component({
  selector: 'app-swap-alert',
  standalone: true,
  templateUrl: './swap-alert.component.html',
  styleUrls: ['./swap-alert.component.scss'],
  imports: [CommonModule, FormsModule, TranslateModule, RouterModule, SettingsComponent, BlurOnClickDirective, SwapMarketViewerComponent, SwapGasTrendViewerComponent, TokenPriceAlertViewerComponent, GasPriceAlertViewerComponent, MockAlertSwiperComponent, SwiperStandaloneComponent, SideNavComponent, TokenSelectorComponent]
})



export class SwapAlertComponent implements OnInit, OnDestroy {
  alerts: Alert[] = [];
  token = '';
  alertType = 'gasCost';
  threshold: number | null = null;
  trigger = 'Supérieur à';
  filterText = '';
  sortOrder: 'asc' | 'desc' = 'asc';
  tokenList = Object.keys(TOKEN_ADDRESS_MAP);
  formSubmitted = false;
  isLoading = false;
  provider: BrowserProvider | null = null;
  takerAddress: string | null = null;
  quote: any;
  signature: string | null = null;
  showWalletWarning = false;
  subscriptionStatus: 'pending' | 'inactive' | 'active' = 'pending'; // État initial en attente
  selectedTab: 'token' | 'gas' = 'token';
  quotePreview: number | null = null;
  sellTokenSearch: string = '';
  buyTokenSearch: string = '';
  filteredSellTokens: any[] = [];
  filteredBuyTokens: any[] = [];
  currentGasPriceGwei: number = 0;
  defaultTokenA: string = '';
  defaultTokenB: string = '';
  initialTokenIn: string = '';
  initialTokenOut: string = '';
  initialAmountIn: number = 0;
  defaultTokenIn: string = '';
  defaultTokenOut: string = '';
  showSettings = false;
  showChainMenu = false;
  showFooterMenu = false;
  // --- Gestion WalletConnect / persistance ---
  session: any = null;
  walletConnectURI: string = '';
  isConnected: boolean = false;
  showWcModal = false;       // contrôle l’affichage
  wcUri: string = '';
  encodeURIComponent = encodeURIComponent;
  currentChainId = 1;
  private checkInterval$: Subscription | null = null;
  private filterSubject = new Subject<string>();
  private intervalMap = new Map<string, number>(); 
  private hasHandledInitialParams = false;
  public showSellDropdown = false;
  chainId: number | null = null;            // ex. 1, 42161, 137…
  chainInfo: { name: string; icon: string } | null = null;
  private sub!: Subscription;
  readonly CHAIN_MAP = CHAIN_MAP;
  showBuyDropdown = false;
  defaultFiat = 'EUR';
  currencySymbol: string = '$'; // valeur par défaut
  showTokenThresholdInput: boolean = true;
  showGasFeeInput: boolean = true;
  showMarketViewer = false;
  showGasTrendViewer = false;
  private quoteUpdateSubject = new Subject<void>();
  private quoteUpdateSub?: Subscription;
  isQuoteLoading = false;
  showActiveMessage = false; // 🔔 variable pour le message
  isGasTrendLoading = false;
  hasGasTrendData = false;
  _gasTrendPercentModel: number = 0;
  isCreatingAlert = false;
  userHasModifiedThreshold = false;
  nativeTokenUsd = 0;
  fiatConversionRate: number = 1;  // valeur par défaut = USD
  isTrendLoading = false;
  hasMarketTrendData = true;
  userTokens: any[] = [];
  popularTokens: any[] = [];
  tokenBalances: Record<string, string> = {};
  showTokenModal = false;
  showBuyTokenModal = false;
  currentGasPriceWei: number | null = null;
  isAlertsLoading = true; // initialisé à true
  constructor(
    private nativeTokenPrice: NativeTokenPriceService,
    private alertService: AlertService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private translate: TranslateService,
    private wallet: WalletService,
    private swapApi: SwapApiService,
    private cd: ChangeDetectorRef,
    private connector: WalletConnectorService,
    private zone: NgZone,
    private price: PriceService
  ) {// Charger la langue sauvegardée au démarrage
    const savedLang = localStorage.getItem('lang') || 'en'; // Langue par défaut : 'en'
    this.translate.use(savedLang); // Définir la langue au démarrage
  }
  priceMap: Record<string, number> = {};
  private symbolByChainId: Record<number, string> = {
    1: 'ETH',
    42161: 'ETH',
    137: 'MATIC',
    56: 'BNB',
    10: 'ETH',
    43114: 'AVAX'
  };


  mockAlerts: Alert[] = [
    {
      id: 'mock-1',
      alertType: 'tokenPrice',
      tokenIn: 'USDC',
      tokenOut: 'ETH',  // ⬅️ MATIC → ETH
      amountIn: 100,
      threshold: 0.0312,  // ⬅️ Seuil de déclenchement : attendre au moins 0.0312 ETH
      trigger: 'Supérieur à',
      chainId: 137,
      active: true,
      triggered: true,
      conditionMode: 'AND',
      maxGasFee: 261960000,
      currentGasFee: 30000000000,
      liveQuote: 0.0301, // ⬅️ Ce qu'on reçoit actuellement (donc pas encore déclenché)
      initialAmountOut: 0.0289,
      initialGasFee: 30000000000,
      isExpanded: false,
      createdAt: new Date().toISOString()
    },
    {
      id: 'mock-2',
      alertType: 'tokenPrice',
      tokenIn: 'ETH',
      tokenOut: 'DAI',
      amountIn: 0.5,
      threshold: 1000,
      trigger: 'Inférieur à',
      chainId: 1,
      active: true,
      triggered: false,
      conditionMode: 'AND',
      maxGasFee: 60000000000,
      currentGasFee: 45000000000,
      liveQuote: 950,
      initialAmountOut: 920,
      initialGasFee: 42000000000,
      isExpanded: false,
      createdAt: new Date().toISOString()
    },
    {
      id: 'mock-3',
      alertType: 'tokenPrice',
      tokenIn: 'USDT',
      tokenOut: 'ARB',
      amountIn: 50,
      threshold: 80.2,
      trigger: 'Inférieur à',
      chainId: 42161,
      active: true,
      triggered: false,
      conditionMode: 'AND',
      maxGasFee: 30000000000,
      currentGasFee: 25000000000,
      liveQuote: 74.3,
      initialAmountOut: 70.1,
      initialGasFee: 22000000000,
      isExpanded: false,
      createdAt:new Date().toISOString()
    }
  ];

  currentAlertIndex = 0;

onSwipeIndexChanged(delta: number) {
  const newIndex = this.currentAlertIndex + delta;
  if (newIndex >= 0 && newIndex < this.mockAlerts.length) {
    this.currentAlertIndex = newIndex;
  }
}

  marketTrendData: {
    amount: number;
    trends: { '1h': number; '6h': number; '24h': number };
  } | null = null;

  private transformToInterpolatedTrend(rawData: any): {
    amount: number;
    trends: { '1h': number; '6h': number; '24h': number };
  } {
    console.log('[🔍 transformToInterpolatedTrend] data reçu :', JSON.stringify(rawData, null, 2));

    const trendMap: Record<'1h' | '6h' | '24h', number> = {
      '1h': 0,
      '6h': 0,
      '24h': 0
    };

    for (const entry of rawData?.data ?? []) {
      const timeframe = entry?.timeframe as '1h' | '6h' | '24h';
      const pct = entry?.pctFromNow;
      if (timeframe && typeof pct === 'number' && timeframe in trendMap) {
        trendMap[timeframe] = pct;
      }
    }

    return {
      amount: this.alert.amountIn ?? 0,
      trends: {
        '1h': trendMap['1h'],
        '6h': trendMap['6h'],
        '24h': trendMap['24h']
      }
    };
  }
  get isSubscriptionInactive(): boolean {
  console.log('SubscriptionStatus ',this.subscriptionStatus);
  return this.subscriptionStatus === 'inactive';
}

  
  gasTrendData: Record<'1h' | '3h' | '6h' | '24h', number> = {
    '1h': 0,
    '3h': 0,
    '6h': 0,
    '24h': 0
  };
  private preloadGasTrendData(): void {
    console.log('[⚠️ preloadGasTrendData]');
    if (!this.chainId) {
      console.warn('[⚠️ preloadGasTrendData] chainId manquant');
      this.isGasTrendLoading = false;
      this.hasGasTrendData = false;
      return;
    }

    this.isGasTrendLoading = true;
    this.hasGasTrendData = false;

    this.swapApi.getGasPriceTrendDune(this.chainId).subscribe({
      next: (trendData) => {
        if (!trendData) {
          console.warn('[⚠️ preloadGasTrendData] trendData vide ou null');
          this.isGasTrendLoading = false;
          this.hasGasTrendData = false;
          return;
        }



        this.gasTrendData = {
          '1h': trendData['1h'] ?? 0,
          '3h': trendData['3h'] ?? 0,
          '6h': trendData['6h'] ?? 0,
          '24h': trendData['24h'] ?? 0
        };

        const nonZero = Object.values(this.gasTrendData).some(v => v !== 0);
        this.hasGasTrendData = nonZero;

        console.log('[✅ preloadGasTrendData] Résultat:', this.gasTrendData);
        this.isGasTrendLoading = false;
      },
      error: (err) => {
        console.error('[❌ preloadGasTrendData] Dune API error:', err);
        this.isGasTrendLoading = false;
        this.hasGasTrendData = false;
      }
    });
  }
  get currentMockAlert(): Alert {
  return this.mockAlerts[this.currentAlertIndex];
}
get effectiveAlert(): Alert {
  return this.isSubscriptionInactive ? this.mockAlerts[this.currentAlertIndex] : this.alert;
}


  getDefaultSellTokenForChain(chainId: number): any {
    console.log('🔍 Param chainId reçu =', chainId, 'type =', typeof chainId);

    this.availableTokens.forEach((t, i) => {
      console.log(
        `#${i} symbol=${t.symbol} | chainId=`,
        t.chainId,
        '| type=', typeof t.chainId
      );
    });

    const tokens = this.availableTokens
      .filter(t => String(t.chainId) === String(chainId))
      .sort((a, b) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0));

    console.log('🎯 Tokens filtrés:', tokens);

    return tokens.length > 0 ? tokens[0] : undefined;
  }

  getDefaultBuyTokenForChain(chainId: number): any {
    const tokens = this.popularTokens
      .filter(t => t.chainId === chainId)
      .sort((a, b) => b.volumeUsd24h - a.volumeUsd24h);

    return tokens.length > 1 ? tokens[1] : undefined;
  }
  private refreshTokensForChain(): void {
    this.swapApi.getAvailableTokens().subscribe({
      next: allTokens => {
        /* 1) NE GARDE QUE LE RÉSEAU COURANT ------------------------- */
        const tokens = allTokens.filter(
          t => Number(t.chainId) === this.chainId          // ou === this.currentChainId
        );

        /* 2) Trie et stocke ----------------------------------------- */
        this.availableTokens = tokens.sort((a, b) =>
          a.symbol.localeCompare(b.symbol)
        );
        // ✅ Construire priceMap avec clé unique chainId_address
        this.priceMap = {};
        for (const token of this.availableTokens) {
          if (token.symbol && token.priceUSD) {
            const key = `${token.address.toLowerCase()}_${token.chainId}`;
            this.priceMap[key] = parseFloat(token.priceUSD);
          }
        }
        /* 3) Sécurise tokenIn / tokenOut ---------------------------- */
        if (!this.availableTokens.some(t => t.symbol === this.alert.tokenIn)) {
          this.alert.tokenIn = this.availableTokens[0]?.symbol ?? '';
        }
        if (!this.availableTokens.some(t => t.symbol === this.alert.tokenOut)) {
          // évite d’avoir le même symbole deux fois
          this.alert.tokenOut =
            (this.availableTokens.find(t => t.symbol !== this.alert.tokenIn)?.symbol) ||
            this.alert.tokenIn;
        }

        /* 4) Reconstruit les fenêtres pour les dropdowns ------------- */
       
        this.filteredSellTokens = [...this.availableTokens];
        this.filteredBuyTokens = [...this.availableTokens];

        /* 5) Aperçu + soldes ---------------------------------------- */
       /* this.loadAllBalances();*/
      },
      error: err => console.error('[SwapAlert] refreshTokensForChain', err)
    });


    // Appel uniquement si la liste n’est pas vide
    if (this.availableTokens.length) {
      this.popularTokens = [...this.availableTokens].sort((a, b) =>
        (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
      );
      console.log("refreshTokensForChain()", this.popularTokens);
      if (this.takerAddress) {
        this.loadBalancesOptimized();
      }
    } else {
      console.warn('[Tokens] Liste vide, balances non chargées');
    }


  }

  private applyQueryParamsToMock(): void {
    this.route.queryParams.subscribe(params => {
      const tokenIn = params['tokenIn'];
      const tokenOut = params['tokenOut'];
      const amountInRaw = params['amountIn'];
      const amountOutRaw = params['amountOut'];
      const maxGasFeeRaw = params['maxGasFee'];

      const mock = this.mockAlerts[0]; // 🔁 mock-1

      if (tokenIn) mock.tokenIn = tokenIn;
      if (tokenOut) mock.tokenOut = tokenOut;

      if (amountInRaw) {
        const amountIn = parseFloat(amountInRaw.replace(',', '.'));
        if (!isNaN(amountIn)) mock.amountIn = amountIn;
      }

      if (amountOutRaw) {
        const amountOut = parseFloat(amountOutRaw.replace(',', '.'));
        if (!isNaN(amountOut)) {
          mock.liveQuote = amountOut;
          mock.threshold = +(amountOut * 1.025).toFixed(6);
        }
      }

      if (maxGasFeeRaw) {
        const maxGasFee = parseFloat(maxGasFeeRaw.replace(',', '.'));
        if (!isNaN(maxGasFee)) mock.maxGasFee = maxGasFee;
      }

      console.log('[✅ mockAlert mis à jour depuis URL]', mock);
    });
  }




  async ngOnInit(){
    const currency = localStorage.getItem('currency') || 'USD';

    switch (currency) {
      case 'EUR':
      case '€':
        this.currencySymbol = '€';
        break;
      case 'XOF':
      case 'CFA':
        this.currencySymbol = 'F CFA';
        break;
      case 'BTC':
        this.currencySymbol = '₿';
        break;
      case 'ETH':
        this.currencySymbol = 'Ξ';
        break;
      default:
        this.currencySymbol = '$';
        break;
    }
    this.route.queryParams.subscribe(params => {
      const { tab, threshold } = params;
      if (tab === 'gas') {
        this.setTab('gas');
        const th = parseFloat(threshold);
        if (!isNaN(th) && th > 0) {
          this.alert.threshold = th;        // pré-remplit la valeur
        } else {
          this.setDefaultGasThreshold();    // fallback à –5 % si besoin
        }
        this.cdr.detectChanges();
      }
    });
    this.sub = this.wallet.chainId$.subscribe(id => {
      this.zone.run(() => {
        if (id !== null) {
          this.chainId = id;
          this.currentChainId = id;          // ← AJOUT
          this.chainInfo = id ? CHAIN_MAP[id] ?? null : null;
          this.swapApi.setChainId(id);
          this.refreshTokensForChain(); // <<< ici
          this.fetchCurrentGasInGwei();
          /*this.loadAllBalances();*/
          this.preloadGasTrendData(); // ✅ ajout ici
          this.cd.detectChanges();
        }
      });
    });


    this.wallet.address$.subscribe(addr => {      // ➋ NOUVEL observateur
      if (addr) {
        this.takerAddress = addr;
        localStorage.setItem('wallet', addr);     // assure la persistance
        this.cdr.detectChanges();
      }
    });
    

    this.wallet.wcUri$.subscribe(uri => {
      this.wcUri = uri ?? '';
      this.showWcModal = !!uri;
    });
    this.handleQueryParams();
    this.applyQueryParamsToMock();
    this.loadTokens();
    this.fetchCurrentGasInGwei();
    if (this.alert.tokenA) this.defaultTokenA = this.alert.tokenA;
    if (this.alert.tokenB) this.defaultTokenB = this.alert.tokenB;
    setInterval(() => {
      if (this.selectedTab === 'gas') {
        this.fetchCurrentGasInGwei();
      }
    }, 5 * 60 * 1000);

    this.refreshLiveQuotes();
    setInterval(() => // 🔁 Recharge les alertes, alertes déjà enrichies par backend
      this.alertService.getAlerts(this.takerAddress?.toLowerCase()!).subscribe(alerts => {
        console.log('📥 Alertes reçues depuis le backend:', alerts);

        alerts.forEach((alert, index) => {
          console.log(`🔎 Alerte #${index + 1} (ID: ${alert.id})`);
          console.log('   ➤ liveQuote:', alert.liveQuote);
          console.log('   ➤ currentGasFee:', alert.currentGasFee); // 👈 LOG ICI
          console.log('   ➤ alertType:', alert.alertType);
          console.log('   ➤ threshold:', alert.threshold);
          console.log('   ➤ initialGasFee:', alert.initialGasFee);
          console.log('   ➤ maxGasFee:', alert.threshold);

        });
        this.alerts = alerts;
        this.isAlertsLoading = false;
        // Plus besoin de setInterval ici !
      }), 1 * 60 * 1000); // toutes les 5 minutes
    // Sync theme from localStorage
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      document.body.classList.remove('light-mode', 'dark-mode');
      document.body.classList.add(savedTheme + '-mode');
    }

    const savedWallet = localStorage.getItem('wallet');
    const savedSubscription = localStorage.getItem('subscription');

    if (savedWallet) {
      this.takerAddress = savedWallet;

      // Applique d'abord l'état local (rapide, évite clignotement)
      if (savedSubscription === 'active') {
        this.subscriptionStatus = 'active';
      } else {
        this.subscriptionStatus = 'inactive'; // ← sécurité si autre valeur ou null
      }

      // Toujours revalider via le backend (source de vérité)
      this.checkSubscriptionStatus(savedWallet);
    } else {
      // 🔄 Si aucun wallet en mémoire, tenter de restaurer via session WalletConnect
      this.restoreWalletSession(); // ← doit appeler checkSubscriptionStatus() aussi
    }

 

    
    


    // Debounce filter input
    this.filterSubject.pipe(debounceTime(300)).subscribe(text => {
      this.filterText = text;
    });

     this.quoteUpdateSub = this.quoteUpdateSubject.pipe(
    debounceTime(600)
  ).subscribe(() => {
  console.log('[🔥] Debounced updateQuotePreview triggered');
  this.updateQuotePreview();
});

    if (this.chainId == null) {
      this.setChain(1);        // remplit chainId + chainInfo
      this.currentChainId = 1; // garde les deux props en phase
      this.swapApi.setChainId(1);
    }
    this.refreshTokensForChain();

    if (
      this.showGasFeeInput &&
      this.showTokenThresholdInput &&
      !this.alert.conditionMode
    ) {
      this.alert.conditionMode = 'AND';
    }

    
      this.fetchCurrentGasCost();
    

    this.nativeTokenUsd = await this.nativeTokenPrice.getUsdPrice(this.chainId ?? 1);
    this.updateDisplayedGasFiat();
    const nativeSymbol = this.symbolByChainId[this.chainId ?? 1] || 'ETH';
    this.price
      .fetchPrices([nativeSymbol], this.defaultFiat.toLowerCase())
      .subscribe(map => {
        console.log(`[💸] Nouveau priceMap pour ${nativeSymbol} → ${this.defaultFiat} :`, map);
        this.updateDisplayedGasFiat();
      });

    this.setupMarketTrendPreloadDebounce();
  }

  async loadBalancesOptimized() {
    if (!this.takerAddress) return;

    console.log("🚀 [loadBalancesOptimized] Détection tokens...");

    // 1️⃣ Récupère uniquement les adresses possédées
    const ownedAddresses = await this.wallet.getOwnedTokensRaw(this.takerAddress, this.chainId ?? 1);
    console.log("📌 Adresses possédées:", ownedAddresses);

    if (!ownedAddresses.length) {
      console.warn("⚠️ Aucun token whitelisté trouvé");
      return;
    }

    // 2️⃣ Map vers availableTokens (logo, decimals, etc.)
    const ownedTokens = this.availableTokens.filter(t =>
      ownedAddresses.includes((t.address || '').toLowerCase())
    );
    console.log("✅ Tokens whitelist possédés:", ownedTokens);

    // 2️⃣bis Ajout forcé du token natif si présent dans availableTokens
    const nativeToken = this.availableTokens.find(t =>
      t.address === '0x0000000000000000000000000000000000000000'
    );
    if (nativeToken && !ownedTokens.includes(nativeToken)) {
      ownedTokens.push(nativeToken);
      console.log("💡 Token natif ajouté manuellement:", nativeToken);
    }


    if (!ownedTokens.length) {
      console.warn("⚠️ Aucun token de la whitelist trouvé dans le portefeuille");
      return;
    }

    // 3️⃣ Charge uniquement les balances pour ces tokens
    await this.loadBalancesForTokens(ownedTokens, true);
    console.log("💰 Balances après scan:", this.tokenBalances);

    // 4️⃣ Mets à jour la liste 'Vos tokens'
    // 4️⃣ Mets à jour la liste 'Vos tokens'
    this.userTokens = ownedTokens.filter(t => {
      const key = `${t.address.toLowerCase()}_${t.chainId}`;
      return parseFloat(this.tokenBalances[key] || '0') > 0;
    });

    console.log("🎯 Tokens affichés dans 'Vos tokens':", this.userTokens);

    // 5️⃣ Trie des populaires
    this.popularTokens = [...this.availableTokens].sort(
      (a, b) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
    );

    console.log("🏁 [loadBalancesOptimized] Terminé ✅");
  }
  private handleQueryParams(): void {
    this.route.queryParams.subscribe(params => {
      const { tokenIn, tokenOut, amountIn, amountOut, maxGasFee } = params;

      if (tokenIn) {
        this.alert.tokenIn = tokenIn;
        this.defaultTokenIn = tokenIn;
      }

      if (tokenOut) {
        this.alert.tokenOut = tokenOut;
        this.defaultTokenOut = tokenOut;
      }

      if (amountIn) {
        const parsed = parseFloat(amountIn);
        this.alert.amountIn = isNaN(parsed) ? 0 : parsed;
        this.initialAmountIn = this.alert.amountIn;
      }

      if (amountOut) {
        const parsed = parseFloat(amountOut);
        this.quotePreview = isNaN(parsed) ? 0 : parsed;
      }

      if (maxGasFee) {
        const parsed = parseFloat(maxGasFee);
        this.currentGasPriceWei = isNaN(parsed) ? null : parsed; 
        this.alert.maxGasFee = isNaN(parsed) ? null : parsed; 
      }

      if (tokenIn || tokenOut || amountIn) {
        this.selectedTab = 'token';
        this.alert.alertType = 'tokenPrice';
      }

      this.hasHandledInitialParams = true;
      this.tryUpdateQuotePreview(); // tentative sécurisée
    });
  }


  private loadTokens(): void {
    this.swapApi.getAvailableTokens().subscribe(tokens => {
      this.availableTokens = tokens;
      this.tryUpdateQuotePreview(); // relance la preview si besoin
    });
  }

  private tryUpdateQuotePreview(): void {
    if (
      this.hasHandledInitialParams &&
      this.availableTokens.length > 0 &&
      this.alert.tokenIn &&
      this.alert.tokenOut &&
      this.alert.amountIn &&
      this.alert.amountIn > 0
    ) {
      if (!this.userHasModifiedThreshold && this.selectedTab === 'token') {
        if (this.quotePreview  && this.quotePreview > 0) {
          this.alert.threshold = +(this.quotePreview * 1.025).toFixed(6);
        }
      }

      this.updateQuotePreview();
    }
  }
  get currentGasGwei(): number {
    

    if (!this.currentGasPriceWei) return 0;

    const gwei = this.currentGasPriceWei / 1e9;
    const precision = gwei < 1 ? 5 : 2; // même logique que displayedGas
    return parseFloat(gwei.toFixed(precision));
  }

  get displayedGas(): number {
  /*  console.log("[key]",this.alert?.maxGasFee)*/
    if (!this.alert?.maxGasFee) return 0;

    const gwei = this.alert.maxGasFee / 1e9;
    const precision = gwei < 1 ? 5 : 2; // plus de décimales si < 1 Gwei
    return parseFloat(gwei.toFixed(precision));
  }


  get displayedGasFiatFormatted(): string {
    const rawFiat = this.displayedGas;

    if (rawFiat === 0 || isNaN(rawFiat)) return '';

    const digits = rawFiat >= 1 ? 2 : 4;

    return rawFiat.toLocaleString('fr-FR', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    });
  }

  set displayedGas(fiatValue: number) {
    console.warn('[❌] Ne pas utiliser setter displayedGasFiat pour modifier maxGasFee automatiquement !');
  }


  getTokenAddress(symbol: string, chainId: number): string {
  const token = this.availableTokens.find(t => t.symbol === symbol);
  if (!token) return '';
  
  // Cas spécial ETH
  if (symbol === 'ETH') {
    return chainId === 1
      ? '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'       // Ethereum
      : chainId === 42161
        ? '0x82af49447d8a07e3bd95bd0d56f35241523fbab1'     // Arbitrum
        : token.address;
  }

  return token.address;
}


  getTokenBalance(symbol: string): string {
    const token = this.userTokens.find(
      t => t.symbol === symbol && t.chainId === this.chainId
    );
    if (!token) return '';

    const key = `${token.address.toLowerCase()}_${token.chainId}`;
    const balance = this.tokenBalances[key];
    if (!balance) return '';

    const parsed = parseFloat(balance);
    return formatTokenAmount(parsed);
  }

  async changeChain(id: number) {
    this.showChainMenu = false;

    try {
      const isConnected = !!this.takerAddress;

      if (isConnected) {
        await this.wallet.switchChain(id);
      } else {
        // Mise à jour locale
        this.chainId = id;
        this.chainInfo = CHAIN_MAP[id];
        this.swapApi.setChainId(id);
      }
      // 🔄 Attendre le rechargement réel des tokens
      await this.refreshTokensForChain();

      // Vérifier que popularTokens n'est pas vide
      console.log("popularTokens après refresh", this.popularTokens);

      // Sélectionner les tokens par défaut
      const sellToken = this.getDefaultSellTokenForChain(id);
      const buyToken = this.getDefaultBuyTokenForChain(id);

      console.log("sellToken =", sellToken);
      console.log("buyToken =", buyToken);

      if (sellToken?.symbol) this.selectSellToken(sellToken.symbol);
      if (buyToken?.symbol) this.selectBuyToken(buyToken.symbol);

      this.cd.detectChanges();

    } catch (e) {
      console.error('⛔️ Erreur de changement de réseau', e);
      alert('Impossible de changer de réseau : ' + (e as any).message);
    }
  }

  formatTokenAmount(value: number): string {
    if (value >= 1) return value.toFixed(4).replace(/\.?0+$/, '');
    if (value >= 0.01) return value.toFixed(5).replace(/\.?0+$/, '');
    if (value >= 0.000001) return value.toFixed(7).replace(/\.?0+$/, '');
    return value.toExponential(2); // ex: 1.23e-6
  }

  toggleMarketViewer(): void {
    this.showMarketViewer = !this.showMarketViewer;
  }

  get currentSwapAmount(): number {
    return typeof this.quotePreview === 'number' ? this.quotePreview : 0;
  }

  onTrendSelected(percent: number): void {
    const quote = this.currentSwapAmount;
    if (!quote || percent === undefined) return;

    const factor = 1 + percent / 100;
    const newThreshold = +(quote * factor).toFixed(6);

    this.alert.threshold = newThreshold;
  }

  onGasTrendSelected(percent: number): void {
    const gasNow = this.currentGasPriceWei; // ⚠️ en wei
    console.log('🔍 gasNow =', gasNow, 'percent =', percent);
    if (!gasNow || percent === undefined) return;

    const factor = 1 + percent / 100;
    this.alert.maxGasFee = +(gasNow * factor); // 🔁 en wei
    console.log('✅ New maxGasFee (wei) =', this.alert.maxGasFee);
    this._syncGasTrendPercent(gasNow, this.alert?.maxGasFee);
  /*  this._syncGasTrendPercent(); // met à jour le pourcentage*/
  }



  castToTokenPriceAlertInput(alert: Alert): TokenPriceAlertInput {
    return {
      alertType: alert.alertType,
      amountIn: alert.amountIn ?? 0,
      tokenIn: alert.tokenIn ?? '',
      tokenOut: alert.tokenOut ?? '',
      threshold: alert.threshold,
      conditionMode: alert.conditionMode ?? 'AND',
      maxGasFee: alert.maxGasFee ?? undefined,
      liveQuote: alert.liveQuote ?? undefined,
      chainId: alert.chainId,
      triggered: alert.triggered,
      active: alert.active,
      currentGasFee: alert.currentGasFee ?? undefined
    };
  }

castToFullAlert(alert: Partial<Alert>): Alert {
  return {
    id: alert.id ?? 'fallback-id',
    trigger: alert.trigger ?? '',
    alertType: alert.alertType ?? 'tokenPrice',
    amountIn: alert.amountIn ?? 0,
    tokenIn: alert.tokenIn ?? '',
    tokenOut: alert.tokenOut ?? '',
    threshold: alert.threshold ?? 0,
    conditionMode: alert.conditionMode ?? 'AND',
    maxGasFee: alert.maxGasFee ?? null,
    liveQuote: alert.liveQuote ?? undefined,
    currentGasFee: alert.currentGasFee ?? undefined,
    chainId: alert.chainId ?? 1,
    triggered: alert.triggered ?? false,
    active: alert.active ?? true,
    initialGasFee : alert.initialGasFee ?? undefined,
    initialAmountOut : alert.initialAmountOut ?? undefined,
    createdAt: alert.createdAt ?? undefined // ✅ AJOUTE CETTE LIGNE
  };
}



  onAmountChanged(): void {
    console.log('[📥] onAmountChanged triggered');
    /*this.isQuoteLoading = true;*/
    this.quoteUpdateSubject.next();
    this.marketTrendUpdateSubject.next();  // 👈 ajouté

  }

  onSellTokenClick(event: MouseEvent, symbol: string) {
    event.stopPropagation();
    this.selectSellToken(symbol);
    this.onTokenInChanged();
    setTimeout(() => {
      this.showSellDropdown = false;
    }, 0);
  }

  onBuyTokenClick(event: MouseEvent, symbol: string) {
    event.stopPropagation();
    this.selectBuyToken(symbol);
    this.onTokenOutChanged();
    setTimeout(() => {
      this.showBuyDropdown = false;
    }, 0);
  }


  onTokenInChanged(): void {
    console.log('[📥] onTokenInChanged triggered');
    /*this.isQuoteLoading = true;*/
    this.quoteUpdateSubject.next();
    this.marketTrendUpdateSubject.next();  // 👈 ajouté

  }


onTokenOutChanged(): void {
  console.log('[📥] onTokenOutChanged triggered');
  /*this.isQuoteLoading = true;*/
  this.quoteUpdateSubject.next();
  this.marketTrendUpdateSubject.next();  // 👈 ajouté

  }

  private marketTrendUpdateSubject = new Subject<void>();

  private setupMarketTrendPreloadDebounce(): void {
    this.marketTrendUpdateSubject.pipe(debounceTime(600)).subscribe(() => {
      if (
        this.alert.tokenIn &&
        this.alert.tokenOut &&
        this.alert.amountIn &&
        this.alert.amountIn > 0 &&
        this.chainId
      ) {
        this.preloadMarketTrendData();
      }
    });
  }

  private preloadMarketTrendData(): void {
    const { tokenIn, tokenOut, chainId, amountIn} = this.alert;

    if (!tokenIn || !tokenOut || !amountIn || !chainId || amountIn === 0) {
      console.warn('[⚠️ preloadMarketTrendData] Données incomplètes');
      this.isTrendLoading = false;
      this.hasMarketTrendData = false;
      return;
    }
    this.isQuoteLoading = true;
    const tokenInAddress = this.getTokenAddress(tokenIn, chainId);
    const tokenOutAddress = this.getTokenAddress(tokenOut, chainId);

    this.isTrendLoading = true;

    console.log('[📊] Préchargement des tendances marché lancé avec :', {
      tokenIn,
      tokenOut,
      tokenInAddress,
      tokenOutAddress,
      amountIn
    });

    this.swapApi.getMarketTrends(
      tokenInAddress,
      tokenOutAddress,
      chainId,
      amountIn
    ).subscribe({
      next: (data) => {
        this.isTrendLoading = false;
        this.marketTrendData = this.transformToInterpolatedTrend(data);
        this.hasMarketTrendData = Object.values(this.marketTrendData.trends).some(v => v !== 0);
        console.log('[✅] Tendances marché chargées :', this.marketTrendData);
      },
      error: (err) => {
        this.isTrendLoading = false;
        this.hasMarketTrendData = false;
        console.error('[❌] Erreur getMarketTrends', err);
      }
    });
  }




  getSafeAlert(alert: Partial<Alert>): Alert {
    return {
      id: alert.id ?? crypto.randomUUID(),                    // ✅ obligatoire
      alertType: alert.alertType ?? 'tokenPrice',
      amountIn: alert.amountIn ?? 0,
      tokenIn: alert.tokenIn ?? '',
      tokenOut: alert.tokenOut ?? '',
      threshold: alert.threshold ?? 0,
      conditionMode: alert.conditionMode ?? 'AND',
      maxGasFee: alert.maxGasFee ?? null,                     // ✅ number | null
      liveQuote: alert.liveQuote ?? null,                     // ✅ optionnel mais propre
      chainId: alert.chainId ?? 1,
      triggered: alert.triggered ?? false,
      active: alert.active ?? true,
      trigger: alert.trigger ?? 'Inférieur à',                // ✅ obligatoire
      token: alert.token ?? '',
      tokenA: alert.tokenA ?? '',
      tokenB: alert.tokenB ?? '',
      condition: alert.condition ?? 'Inférieur à'
    };
  }




  get percentageExpected(): number {
    const minAmount = this.alert?.threshold;
    const current = this.currentSwapAmount;
    if (!minAmount || !current) return 0;

    const raw = ((minAmount - current) / current) * 100;
    return parseFloat(raw.toFixed(1)); // ✅ force 1 décimale toujours
  }
  get gasTrendPercent(): number {
    const current = this.currentGasPriceWei;
    const maxFee = this.alert?.maxGasFee;

    console.log('[GET %] currentSwapCost =', current);
    console.log('[GET %] alert.maxGasFee =', maxFee);

    if (!current || !maxFee) {
      console.warn('[GET %] Retourne 0 car current ou maxFee manquant');
      return 0;
    }

    const percent = ((current - maxFee) / current) * 100;
    const rounded = parseFloat(percent.toFixed(1));

    console.log(`[GET %] Calculé : (${current} - ${maxFee}) / ${current} * 100 = ${percent}`);
    console.log('[GET %] Arrondi à', rounded);

    return rounded;
  }

  _syncGasTrendPercent(current: number, maxFee: number): void {
    if (typeof current === 'number' && typeof maxFee === 'number' && current !== 0) {
      const percent = ((current - maxFee) / current) * 100;
      const rounded = parseFloat(percent.toFixed(1));

      // Only update if the value has changed to avoid loops
      if (this._gasTrendPercentModel !== rounded) {
        this._gasTrendPercentModel = rounded;
        console.log('[SYNC] _gasTrendPercentModel mis à jour depuis maxGasFee =', rounded);
      }
    }
  }

  set gasTrendPercent(value: number | string) {
    console.log('[SET %] % reçu =', value);
    const parsed = Number(value);
    this._gasTrendPercentModel = parsed;

    console.log('[SET %] % reçu =', parsed);

    const current = this.currentGasPriceWei;
    if (typeof current !== 'number' || current === 0 || isNaN(parsed)) {
      console.warn('[SET %] Valeur ignorée :', value);
      return;
    }

    const fee = current * (1 - parsed / 100);
    const rounded = parseFloat(fee.toFixed(6));

    this.alert.maxGasFee = rounded === 0 ? 0 : rounded;

    console.log(`[SET %] Calculé : ${current} * (1 - ${parsed} / 100) = ${fee}`);
    console.log('[SET %] Arrondi à', rounded);
    console.log('[SET %] alert.maxGasFee MAJ =>', this.alert.maxGasFee);
  }




  get gasTrendThreshold(): number {
    const maxFee = this.alert?.maxGasFee;
    const current = this.currentSwapCost;

    console.log('[DEBUG] maxFee :'+maxFee);
    console.log('[DEBUG] current :'+current);
    if (!maxFee || !current) return 0;

    const raw = ((current - maxFee) / current) * 100;
    return parseFloat(raw.toFixed(1)); // ✅ ex: 8.3%
  }

  set gasTrendThreshold(value: number) {
    const current = this.currentSwapCost;
    if (!current || isNaN(value)) return;

    const newMax = current * (1 - value / 100);
    this.alert.maxGasFee = parseFloat(newMax.toFixed(2)); // 🧠 toujours 2 décimales
  }

  onPercentageInput(event: Event): void {
    const value = parseFloat((event.target as HTMLInputElement).value);
    if (!isNaN(value) && this.currentSwapAmount > 0) {
      this.alert.threshold = +(this.currentSwapAmount * (1 + value / 100)).toFixed(6);
    }
  }
  private async loadBalancesUniswapStyle() {
    if (!this.takerAddress) return;

    this.userTokens = [];

    // 1️⃣ Top tokens par volume
    const topTokens = [...this.filteredSellTokens]
      .sort((a, b) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0))
      .slice(0, 20);

    const otherTokens = this.filteredSellTokens.filter(t => !topTokens.includes(t));

    // 2️⃣ Charger les top tokens en priorité
    await this.loadBalancesForTokens(topTokens, true);

    // 3️⃣ Charger les autres en arrière-plan
    setTimeout(() => {
      this.loadBalancesForTokens(otherTokens, false);
    }, 300);
  }

  private async loadBalancesForTokens(tokens: any[], isPriority: boolean) {
    if (!this.takerAddress) return;

    const concurrency = isPriority ? 10 : 5;
    let index = 0;

    const worker = async () => {
      while (index < tokens.length) {
        const token = tokens[index++];
        try {
          const balance = await this.swapApi.getBalance(token, this.takerAddress!, token.chainId);
          const key = `${token.address.toLowerCase()}_${token.chainId}`;
          this.tokenBalances[key] = balance;

          if (parseFloat(balance) > 0) {
            this.userTokens.push(token);
            this.cd.detectChanges();
          }
        } catch {
          const key = `${token.chainId}_${(token.address || '').toLowerCase()}`;
          this.tokenBalances[key] = '0';
        }
      }
    };

    const workers = Array.from({ length: concurrency }, () => worker());
    await Promise.allSettled(workers);
  }


  async loadAllBalances() {
    if (!this.takerAddress) return;

    for (const token of this.filteredSellTokens) {
      try {
        const balance = await this.swapApi.getBalance(token, this.takerAddress, token.chainId);
        const key = `${token.address.toLowerCase()}_${token.chainId}`;
        token.balance = balance;
        this.tokenBalances[key] = balance;
      } catch (e) {
        console.error(`Erreur récupération balance ${token.symbol}`, e);
        const key = `${token.chainId}_${(token.address || '').toLowerCase()}`;
        this.tokenBalances[key] = '0';
      }
    }

    // ✅ Mise à jour "Vos tokens"
    this.userTokens = this.filteredSellTokens.filter(t => {
      const k = `${(t.address || '').toLowerCase()}_${t.chainId}`;
      return parseFloat(this.tokenBalances[k] || '0') > 0;
    });

    // ✅ Mise à jour "Tokens par volume"
    this.popularTokens = [...this.filteredSellTokens].sort((a, b) =>
      (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
    );


    console.log('[📊 tokenBalances] Composant :', this.constructor.name);
    console.table(this.tokenBalances);
  }

  onSellTokenSelectedFromModal(symbol: string) {
    this.selectSellToken(symbol);
    this.onTokenInChanged();
  }

  onBuyTokenSelectedFromModal(symbol: string) {
    this.selectBuyToken(symbol);
    this.onTokenOutChanged();
  }



  selectSellToken(symbol: string) {
    this.alert.tokenIn = symbol;
  }

  getTokenName(symbol: string): string {
    const token = this.filteredSellTokens.find(t => t.symbol === symbol);
    return token?.name || '';
  }
  get isArabicLang(): boolean {
    return this.translate.currentLang === 'ar';
  }
  refreshLiveQuotes(): void {
    this.filteredAndSortedAlerts
      .filter(a => a.alertType === 'tokenPrice')
      .forEach(async a => {
        /* ------------------------------------------------------------------ */
        /* 1) Pré-requis                                                     */
        /* ------------------------------------------------------------------ */
        const tokenInAddress = this.availableTokens.find(t => t.symbol === a.tokenIn)?.address;
        const tokenOutAddress = this.availableTokens.find(t => t.symbol === a.tokenOut)?.address;
        if (!tokenInAddress || !tokenOutAddress || typeof a.amountIn !== 'number') return;

        const amountIn= (a.amountIn).toString();
        const taker =
          this.takerAddress ||
          localStorage.getItem('wallet') ||
          '0x0000000000000000000000000000000000000000';

        /* ------------------------------------------------------------------ */
        /* 2) Appel backend : on passe bien `a.chainId`                        */
        /* ------------------------------------------------------------------ */
        try {
          const res = await this.swapApi.getQuote(
            tokenInAddress,
            tokenOutAddress,
            amountIn,
            taker,
            a.chainId              // 👈 la bonne variable
          ).toPromise();

          a.liveQuote = res?.data?.buyAmount
            ? Number(res.data.buyAmount) / 1e18
            : null;
         

        } catch (err) {
          console.error(
            `[ERROR] Échec liveQuote ${a.tokenIn}/${a.tokenOut} (chain ${a.chainId})`,
            err
          );
          a.liveQuote = null;
        }
      });
  }



  filterTokens(search: string, type: 'sell' | 'buy') {
    const target = search.toLowerCase();

    const filtered = this.availableTokens
      .filter(token => token.symbol.toLowerCase().startsWith(target))
      .sort((a, b) => a.symbol.localeCompare(b.symbol));

    if (type === 'sell') {
      this.filteredSellTokens = filtered;
      if (!filtered.some(t => t.symbol === this.alert.tokenIn)) {
        this.alert.tokenIn = filtered.length > 0 ? filtered[0].symbol : '';
      }
    } else {
      this.filteredBuyTokens = filtered;
      if (!filtered.some(t => t.symbol === this.alert.tokenOut)) {
        this.alert.tokenOut = filtered.length > 0 ? filtered[0].symbol : '';
      }
    }
  }


  ngOnDestroy(): void {
    this.checkInterval$?.unsubscribe();
    this.quoteUpdateSub?.unsubscribe();
  }

  updateQuotePreview(): void {
    console.log('[DEBUG] Appel de updateQuotePreview');
    console.log('AmountIn', this.alert.amountIn);
    console.log('tokenIn', this.alert.tokenIn);
    console.log('tokenout', this.alert.tokenOut);
    console.log('Valeurs saisies :', {
      amountIn: this.alert.amountIn,
      tokenIn: this.alert.tokenIn,
      tokenOut: this.alert.tokenOut
    });

    if (
      this.alert.amountIn &&
      this.alert.amountIn > 0 &&
      this.alert.tokenIn &&
      this.alert.tokenOut &&
      this.alert.tokenIn !== this.alert.tokenOut
    ) {
      const tokenInAddress = this.availableTokens.find(t => t.symbol === this.alert.tokenIn)?.address;
      const tokenOutAddress = this.availableTokens.find(t => t.symbol === this.alert.tokenOut)?.address;
      const taker = this.takerAddress || localStorage.getItem('wallet') || '0x0000000000000000000000000000000000000000';

      console.log('[DEBUG] Adresses tokenIn/tokenOut trouvées :', tokenInAddress, tokenOutAddress);

      if (!tokenInAddress || !tokenOutAddress) {
        this.quotePreview = null;
        console.warn('[WARN] Adresse introuvable pour un des tokens');
        return;
      }

      const amountInWei = (this.alert.amountIn).toString();
      console.log('[DEBUG] Envoi requête à backend avec sellAmount (wei) :', amountInWei);

      
      this.swapApi.getQuote(
        tokenInAddress,
        tokenOutAddress,
        amountInWei,
        taker
      ).subscribe({
          next: res => {
            console.log('[SUCCESS] Réponse de l’API reçue :', res);
            console.log('[DEBUG] Réponse complète :', res);
            console.log('[DEBUG] buyAmount brut :', res?.data?.buyAmount);

            const rawAmount = res?.data?.buyAmount;
            this.quotePreview = Number(String(res.formattedBuyAmount).replace(',', '.'));
          this.quote = {
            gasPriceWei: res?.data?.gasPriceWei ?? null
          };
              // ✅ Ajoute cette ligne
          this.alert.liveQuote = this.quotePreview;

      
            
            const thresholdStr = this.quotePreview *1.025;
        

          if (!isNaN(thresholdStr) && this.selectedTab === 'token') {
            const rawGas = res?.data?.gasPriceWei ?? '0';
            const sanitizedGas = rawGas.toString().replace(/,/g, '');
            this.alert.maxGasFee = Number(sanitizedGas);
            console.log('[DEBUG] this.alert.maxGasFee :', this.alert.maxGasFee);
              this.alert.threshold = thresholdStr;
            /*              this.alert.maxGasFee = Number(String(res?.data?.gasPriceWei ?? null).replace(',', '.'));*/
            this.currentGasPriceWei = this.alert.maxGasFee;
            
            }
            this.isQuoteLoading = false;

            this.cdr.detectChanges(); // ✅ force la détection
          },
          error: err => {
            this.isQuoteLoading = false;

            console.error('[ERROR] Erreur lors du calcul du montant estimé :', err);
            this.quotePreview = null;
          }
        });
    } else {
      console.warn('[WARN] Conditions non remplies pour lancer le calcul');
      this.quotePreview = null;
    }

  }

  getDisplayedAlerts(): Alert[] {
    return this.alerts.filter(alert =>
      this.selectedTab === 'token'
        ? alert.alertType === 'tokenPrice'
        : alert.alertType === 'gasCost'
    );
  }
  fetchCurrentGasInGwei(): void {
    this.http.get<any>(`${environment.backendUrl}/gas/price`, {
      params: { chainId: this.currentChainId },  
      headers: new HttpHeaders({
        'ngrok-skip-browser-warning': '1'
      })
    }).subscribe({
      next: (res) => {
        const gasPriceWei = BigInt(res.gasPriceWei);
        this.currentGasPriceGwei = Number(gasPriceWei) / 1e9; // Conversion Wei -> Gwei

        if (this.selectedTab === 'gas') {
          this.alert.threshold = Number((this.currentGasPriceGwei * 0.95).toFixed(2)); // ✅ seulement si onglet gas
          this.cdr.detectChanges(); // ✅ force la mise à jour de l'UI
        }
        // ✅ Check all gas alerts localement
        this.alerts.forEach((alert, index) => {
          if (alert.alertType === 'gasCost' && alert.active && !alert.triggered) {
            this.checkGasAlert(alert);
          }
        });
        console.log('[DEBUG] Gwei actuel :', this.currentGasPriceGwei, '| Seuil par défaut :', this.alert.threshold);
      },
      error: (err) => {
        console.error('❌ Erreur lors de la récupération du gas price', err);
      }
    });
  }


  fetchCurrentGasCost(): void {
    this.swapApi.getRecommendedGasPrice(this.chainId ?? undefined)  // 💡 ou this.readonlyChainId si pas encore dans la variable
      .then((wei: string) => {
        const gasPriceInGwei = +ethers.formatUnits(wei, 'gwei');
        const eurPerGwei = 0.03; // 🧪 temporaire si tu ne l'as pas dynamiquement
        this.currentSwapCost = +(gasPriceInGwei).toFixed(2);

        console.log('[✔] Coût estimé du swap (EUR):', this.currentSwapCost);

        // Check alerte gas
        this.alerts.forEach(alert => {
          if (alert.alertType === 'gasCost' && alert.active && !alert.triggered) {
            this.checkGasAlert(alert);
          }
        });
      })
      .catch(err => {
        console.error('❌ Erreur dans getRecommendedGasPrice', err);
        this.currentSwapCost = 0;
      });
  }



  updateMaxGasFeeFromFiat(fiat: number): void {
    if (!this.alert || !this.nativeTokenUsd || fiat <= 0) return;
    this.alert.maxGasFee = fiat / this.nativeTokenUsd;
   /* this._syncGasTrendPercent(); // conserve le comportement initial*/
  }

  private setChain(id: number) {
    this.chainId = id;
    this.chainInfo = CHAIN_MAP[id] ?? null;   // si tu n’as pas d’icône pour ce réseau
  }

  getDisplayedGasFee(): number {
  console.log('[🧮] Calcul de la valeur fiat des gas fees…');

  if (!this.alert) {
    console.warn('[❌] Alerte non définie');
    return 0;
  }

  console.log('[📦] maxGasFee (native token) =', this.alert.maxGasFee);
  console.log('[💵] nativeTokenUsd =', this.nativeTokenUsd);

  if (!this.alert.maxGasFee || !this.nativeTokenUsd) {
    console.warn('[⚠️] maxGasFee ou nativeTokenUsd est invalide');
    return 0;
  }

  const result = this.alert.maxGasFee * this.nativeTokenUsd;
  console.log('[✅] Résultat affiché (fiat) =', result);
  return result;
}

  onDisplayedGasChange(value: number): void {
    if (isNaN(value)) return;

    const current = this.currentGasPriceWei;
    const wei = Math.round(value * 1e9); // ✅ conversion Gwei → Wei
    this.alert.maxGasFee = wei;

    console.log('📝 maxGasFee mis à jour (wei) =', wei);

    if (typeof current === 'number' && typeof wei === 'number') {
      this._syncGasTrendPercent(current, wei);
    }
  }






  selectBuyToken(symbol: string) {
    this.alert.tokenOut = symbol;
  }
  getTokenLogo(symbol?: string): string {
    if (!symbol) {
      // logo générique ou icône vide
      return 'assets/tokens/unknown.svg';
    }
    return this.availableTokens.find(t => t.symbol === symbol)?.logoURI;
  }

  setTab(tab: 'token' | 'gas') {
    this.selectedTab = tab;
    this.alert.alertType = tab === 'token' ? 'tokenPrice' : 'gasCost';

    if (!this.hasHandledInitialParams) {
      this.resetForm(tab); // ✅ on n’écrase que si pas de params initiaux
    }
    if (tab === 'token') {
      this.alert.threshold = this.quotePreview ? this.quotePreview * 1.025 : 0;
    }
    if (tab === 'gas') {
      this.setDefaultGasThreshold();
    }
  }

  saveAlert() {
    this.formSubmitted = true;

    if (!this.alert.alertType || this.alert.threshold === null) {
      this.translate.get('INVALID_FORM').subscribe((msg: string) => this.showVisualAlert(msg));
      return;
    }

    let alertToSave: Alert;

    if (this.alert.alertType === 'gasCost') {
      alertToSave = {
        id: this.generateId(), // ✅ nouveau champ requis
        chainId: this.currentChainId,
        alertType: 'gasCost',
        token: 'ETH', // par défaut
        maxGasFee: null,
        threshold: this.alert.threshold,
        trigger: this.alert.trigger,
        condition: this.alert.trigger as 'Supérieur à' | 'Inférieur à',
        active: this.subscriptionStatus === 'active',
        triggered: false
      };
    } else if (this.alert.alertType === 'tokenPrice') {
      if (!this.alert.tokenA || !this.alert.tokenB) {
        this.translate.get('INVALID_FORM').subscribe((msg: string) => this.showVisualAlert(msg));
        return;
      }

      alertToSave = {
        id: this.generateId(), // ✅ idem ici
        chainId: this.currentChainId,
        alertType: 'tokenPrice',
        maxGasFee: this.alert.maxGasFee,
        tokenIn: this.alert.tokenA,
        tokenOut: this.alert.tokenB,
        threshold: this.alert.threshold,
        trigger: this.alert.trigger,
        condition: this.alert.trigger as 'Supérieur à' | 'Inférieur à',
        active: this.subscriptionStatus === 'active',
        triggered: false,
        conditionMode: 'OR' 
      };
    } else {
      console.error('❌ Type d’alerte inconnu');
      return;
    }

    this.alerts.push(alertToSave);
    /*this.saveAlertsToLocalStorage();*/
    this.translate.get('ALERT_SAVED').subscribe((msg: string) => this.showVisualAlert(msg));
    this.resetForm();
  }


  // Une seule alerte en cours de création (lié au formulaire)
  alert: Alert = {
    id: this.generateId(), // ✅ obligatoire
    chainId: this.currentChainId,
    alertType: 'tokenPrice', // ou 'gasCost'
    threshold: 0,
    maxGasFee: null,
    trigger: 'Inférieur à',
    active: true,
    triggered: false,
    amountIn: 0,
    tokenIn: '',
    tokenOut: ''
  };

  private setDefaultGasThreshold(): void {
    if (this.currentGasPriceGwei && this.currentGasPriceGwei > 0) {
      const loweredThreshold = this.currentGasPriceGwei * 0.95;
      this.alert.threshold = +loweredThreshold.toFixed(2);
      this.cdr.detectChanges(); // 🔄 Forcer l'affichage du champ mis à jour

      // ✅ Bonus : afficher une alerte ou message visuel si besoin
      console.log(`[INFO] Seuil par défaut défini à ${this.alert.threshold} Gwei (soit -5%)`);
    }
  }

  // Liste des tokens à afficher dans les dropdowns
  availableTokens: any[] = [];

  // Pour afficher le prix actuel du gas (à calculer ailleurs dans ton composant)
  currentSwapCost: number = 0;
  
  deleteAlert(alert: Alert): void {
    this.alertService.deleteAlert(alert.id!).subscribe(success => {
      if (success) {
        this.alerts = this.alerts.filter(a => a.id !== alert.id);
      }
    });
  }


  // Méthode appelée lors du clic sur "Créer l’alerte"
  async createAlert(): Promise<void> {
    this.isCreatingAlert = true;
    //await this.notificationService.requestPermissionAndStoreToken();
    //const fcmToken = this.notificationService.getFcmToken();
    console.log('✅ currentSwapCost', this.currentSwapCost);

    console.log('✅ maxGasFee', this.alert.maxGasFee);


    console.log('✅ quotePreview', this.quotePreview);


    const fcmToken = 'dev-token-mock';
    const isTokenTab = this.selectedTab === 'token';
    if(isTokenTab)
    {
    this.alert.initialAmountOut = this.quotePreview ?? undefined;
    this.alert.initialGasFee = this.currentSwapCost ?? undefined;
    }

    const alertToSave: Partial<Alert> = {
      wallet: this.takerAddress?.toLowerCase(),
      chainId: this.currentChainId,
      alertType: isTokenTab ? 'tokenPrice' : 'gasCost',
      tokenIn: this.alert.tokenIn,
      tokenOut: this.alert.tokenOut,
      amountIn: this.alert.amountIn,
      threshold: this.alert.threshold,
      trigger: this.alert.trigger,
      maxGasFee: this.alert.maxGasFee ?? undefined,
      liveQuote: isTokenTab ? this.quotePreview ?? undefined : undefined,
      currentGasFee: isTokenTab ? this.currentGasPriceWei ?? undefined : undefined,
      conditionMode: isTokenTab && this.showGasFeeInput && this.showTokenThresholdInput
        ? this.alert.conditionMode ?? 'AND'
        : undefined,
      triggered: false,
      active: true,
      fcmToken: this.getFcmToken(),
      initialAmountOut: isTokenTab ? this.alert.initialAmountOut?? undefined : undefined,
      initialGasFee: isTokenTab ? this.currentGasPriceWei ?? undefined : undefined,
      createdAt: new Date().toISOString(),
      ttlMinutes: 1440
    };


    this.alertService.createAlert(alertToSave).subscribe({
      next: (id: string) => {
        const fullAlert: Alert = {
          ...alertToSave,
          id,
        } as Alert;

        this.alerts.unshift(fullAlert);
        console.log('✅ Alerte créée avec succès', fullAlert);
      },
      error: err => {
        console.error('❌ Erreur lors de la création de l’alerte', err);
      },
      complete: () => {
        this.isCreatingAlert = false; // ✅ Fin du chargement, dans tous les cas
      }
    });

    // Reset partiel
    this.alert.trigger = 'Inférieur à';
    this.alert.triggered = false;
    this.alert.active = true;
  }

//reateAlert() {
//    const isTokenTab = this.selectedTab === 'token';

//    const alertToSave: Alert = {
//      id: this.generateId(),
//      chainId: this.currentChainId,
//      alertType: isTokenTab ? 'tokenPrice' : 'gasCost',
//      tokenIn: this.alert.tokenIn,
//      tokenOut: this.alert.tokenOut,
//      amountIn: this.alert.amountIn,
//      threshold: this.alert.threshold,
//      trigger: this.alert.trigger,
//      maxGasFee: this.alert.maxGasFee ?? null,
//      active: true,
//      triggered: false,
//      liveQuote: isTokenTab ? this.quotePreview ?? undefined : undefined,
//      ...(isTokenTab && this.showGasFeeInput && this.showTokenThresholdInput
//        ? { conditionMode: this.alert.conditionMode ?? 'AND' }
//        : {}) // ✅ injecte uniquement si onglet token + les deux conditions sont visibles
//    };

//    this.alerts.push(alertToSave);
//    this.saveAlertsToLocalStorage();

//    // Réinitialisation partielle
//    this.alert.trigger = 'Inférieur à';
//    this.alert.triggered = false;
//    this.alert.active = true;
//  }


  getTokenLabel(symbol?: string): string {
    if (!symbol) return ''; // ou return '❓' pour afficher un fallback
    const key = 'TOKENS.' + symbol.toUpperCase();
    const translated = this.translate.instant(key);
    return translated !== key ? translated : symbol;
  }


  generateId(): string {
    return 'xxxxxxxx'.replace(/[x]/g, () =>
      (Math.random() * 16 | 0).toString(16)
    );
  }


  handleSubscriptionClick(): void {
    if (!this.takerAddress) {
      this.showWalletWarning = true;
      return;
    }

    this.showWalletWarning = false;
    this.goToSubscription(); // ta fonction actuelle
  }


  resetForm(type: 'token' | 'gas' = this.selectedTab) {
    this.alert = {
      id: this.generateId(),
      chainId: this.currentChainId,
      alertType: type === 'token' ? 'tokenPrice' : 'gasCost',
      tokenIn: type === 'token' ? this.initialTokenIn : '',
      tokenOut: type === 'token' ? this.initialTokenOut : '',
      amountIn: type === 'token' ? this.initialAmountIn : 0,
      threshold: 0,
      trigger: 'Inférieur à',
      active: true,
      triggered: false,
      maxGasFee: this.alert.maxGasFee ?? 0
    };

    this.formSubmitted = false;
  }


  updateDisplayedGasFiat() {
    if (this.alert.maxGasFee != null) {
      this.displayedGas = this.alert.maxGasFee;
      console.log(`💵 Calcul fiat: maxGasFee = ${this.alert.maxGasFee}, usd = ${this.nativeTokenUsd}, rate = ${this.fiatConversionRate}, total = ${this.displayedGas}`);
    }
  }



  removeAlert(indexInDisplay: number): void {
    const displayed = this.getDisplayedAlerts();
    const alertToRemove = displayed[indexInDisplay];
    const indexInGlobal = this.alerts.findIndex(a => a.id === alertToRemove.id);

    if (indexInGlobal !== -1 && alertToRemove.id) {
      this.alertService.deleteAlert(alertToRemove.id).subscribe({
        next: () => {
          this.alerts.splice(indexInGlobal, 1);
          console.log('✅ Alerte supprimée du backend et localement');
        },
        error: err => {
          console.error('❌ Erreur lors de la suppression côté backend :', err);
        }
      });
    }
  }


  resetAllAlerts() {
    this.alerts = [];
    localStorage.removeItem('swapAlerts');
    this.translate.get('ALERTS_RESET').subscribe((message: string) => {
      this.showVisualAlert(message);
    });
  }
  toggleSettings() {
    this.showSettings = !this.showSettings;
  }
  toggleSortOrder() {
    this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
  }

  onFilterChange(text: string) {
    this.filterSubject.next(text);
  }

  get filteredAndSortedAlerts() {
    const filtered = this.alerts.filter(alert => {
      const tokenLabel = alert.token ?? alert.tokenIn ?? '';

      // 🔥 Filtrer selon l'onglet sélectionné
      const correctTab =
        this.selectedTab === 'token' ? alert.alertType === 'tokenPrice' : alert.alertType === 'gasCost';

      return (
        correctTab &&
        tokenLabel.toLowerCase().includes(this.filterText.toLowerCase())
      );
    });

    return filtered.sort((a, b) => {
      const diff = a.threshold - b.threshold;
      return this.sortOrder === 'asc' ? diff : -diff;
    });
  }

  private getFcmToken(): string | undefined {
    // 🔄 Ici tu peux récupérer le token FCM si tu l'as stocké quelque part, par exemple dans localStorage ou un service
    return localStorage.getItem('fcmToken') ?? undefined;
  }

  // Arrondit au dixième, borne optionnelle (à adapter si besoin)
  private round1(x: number) { return Math.round(x * 10) / 10; }
  private clamp(x: number, min = -50, max = 500) { return Math.min(max, Math.max(min, x)); }

  /** Boutons ± pour "Recevoir au moins" */
  nudgePercentage(delta: number): void {
    const cur = Number(this.percentageExpected ?? 0);
    const next = this.clamp(this.round1(cur + delta));
    // Si tu as déjà onPercentageInput(event) qui attend un Event, on le "simule"
    this.onPercentageInput({ target: { value: String(next) } } as any);
  }

  /** Setter appelé par l’input % gas */
  setGasTrendPercent(val: number): void {
    const next = this.clamp(this.round1(Number(val)));
    this._gasTrendPercentModel = next;              // garde le modèle local
    // Répercute dans ta logique existante (adapte selon ton code)
    if (typeof this.onGasTrendSelected === 'function') {
      this.onGasTrendSelected(next);                // ex: applique le pourcentage
    }
  }

  /** Boutons ± pour le % gas */
  nudgeGasTrend(delta: number): void {
    const cur = Number(this._gasTrendPercentModel ?? 0);
    this.setGasTrendPercent(cur + delta);
  }


  async connectWallet() {
    try {
      const { address, provider, chainId } =
        await this.connector.requestConnection();

      // ── votre logique spécifique à la page (balances, UI, etc.) ──
      this.takerAddress = address;
      this.provider = provider;
      this.setChain(chainId);
    /*  await this.loadAllBalances();*/
      this.checkSubscriptionStatus(address); // ← vérifie après connexion
    } catch (e) {
      console.error('Connexion refusée :', e);
    }
  }
  async onCurrencyChanged(code: string) {
    console.log('[🌍] Changement de devise détecté:', code);
    this.defaultFiat = code;
    localStorage.setItem('currency', code);

    // 1) Met à jour le symbole d’affichage
    switch (code.toUpperCase()) {
      case 'EUR':
      case '€': this.currencySymbol = '€'; break;
      case 'XOF':
      case 'CFA': this.currencySymbol = 'F CFA'; break;
      case 'BTC': this.currencySymbol = '₿'; break;
      case 'ETH': this.currencySymbol = 'Ξ'; break;
      default: this.currencySymbol = '$'; break;
    }
    console.log(`[🔁] Symbole monétaire sélectionné : ${this.currencySymbol}`);

    // 2) Token natif courant
    const cid = this.chainId ?? 1;
    const nativeSymbol = this.symbolByChainId[cid] ?? 'ETH';

    // Cherche le token natif dans la liste du réseau courant
    const nativeToken =
      this.availableTokens.find(t => t.symbol === nativeSymbol && Number(t.chainId) === cid)
      // fallback très courant pour le natif: adresse zéro
      ?? this.availableTokens.find(t => t.address?.toLowerCase() === '0x0000000000000000000000000000000000000000' && Number(t.chainId) === cid);

    try {
      const fiatCode = code.toLowerCase();

      if (nativeToken?.address && nativeToken.chainId != null) {
        // ✅ NOUVELLE CLÉ: `${address}_${chainId}`
        const compositeKey = `${nativeToken.address.toLowerCase()}_${nativeToken.chainId}`;
        const priceMap = await firstValueFrom(this.price.fetchPrices([compositeKey], fiatCode));
        this.priceMap = { ...this.priceMap, ...priceMap };

        const unitPrice = priceMap[compositeKey]; // prix 1 token natif -> fiat
        if (!unitPrice || isNaN(unitPrice)) {
          console.warn(`[⚠️] Prix ${compositeKey} → ${code} invalide :`, unitPrice);
          return;
        }

        // ⚠️ maxGasFee est en wei. Pour une valeur fiat correcte:
        // fiat = (maxGasFee / 1e18) * unitPrice
        const maxGasFeeWei = this.alert?.maxGasFee ?? 0;
        const displayedGasFiat = (maxGasFeeWei / 1e18) * unitPrice;

        console.groupCollapsed(`[💸] Conversion du gas en ${code} (clé address_chainId)`);
        console.log(`➤ compositeKey        = ${compositeKey}`);
        console.log(`➤ Prix 1 natif en ${code} = ${unitPrice}`);
        console.log(`➤ maxGasFee (wei)     = ${maxGasFeeWei}`);
        console.log(`✅ Gas en ${code}      = ${displayedGasFiat}`);
        console.groupEnd();

        // Si tu as un champ dédié pour l’affichage fiat, assigne-le ici
        // this.displayedGasFiat = displayedGasFiat; // (optionnel selon ton template)
      } else {
        // 🔙 Fallback: ancien mode (clé par symbole) si on n’a pas trouvé le token natif
        console.warn('[ℹ️] nativeToken introuvable, fallback sur la clé par symbole');
        const priceMap = await firstValueFrom(this.price.fetchPrices([nativeSymbol], fiatCode));
        this.priceMap = { ...this.priceMap, ...priceMap };

        const unitPrice = priceMap[nativeSymbol];
        if (!unitPrice || isNaN(unitPrice)) {
          console.warn(`[⚠️] Prix ${nativeSymbol} → ${code} invalide :`, unitPrice);
          return;
        }

        const maxGasFeeWei = this.alert?.maxGasFee ?? 0;
        const displayedGasFiat = (maxGasFeeWei / 1e18) * unitPrice;

        console.groupCollapsed(`[💸] Conversion du gas en ${code} (fallback symbole)`);
        console.log(`➤ nativeSymbol        = ${nativeSymbol}`);
        console.log(`➤ Prix 1 natif en ${code} = ${unitPrice}`);
        console.log(`➤ maxGasFee (wei)     = ${maxGasFeeWei}`);
        console.log(`✅ Gas en ${code}      = ${displayedGasFiat}`);
        console.groupEnd();

        // this.displayedGasFiat = displayedGasFiat; // (optionnel selon ton template)
      }
    } catch (err) {
      console.error(`[❌] Erreur récupération prix natif → ${code} :`, err);
    }

    this.cd.detectChanges();
  }

  get isGasOpen(): boolean { return !!this.showGasFeeInput; }

  toggleGasOpen() {
    this.showGasFeeInput = !this.showGasFeeInput;
    this.showGasTrendViewer = this.showGasFeeInput; // viewer auto on open
  }

  onGasHeaderKey(e: KeyboardEvent) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.toggleGasOpen(); }
  }


  get isOpen(): boolean { return !!this.showTokenThresholdInput; }

  toggleOpen() {
    this.showTokenThresholdInput = !this.showTokenThresholdInput;
    this.showMarketViewer = this.showTokenThresholdInput; // viewer auto
  }

  onHeaderKey(e: KeyboardEvent) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.toggleOpen(); }
  }


  openWcModal(uri: string): void {
    this.wcUri = uri;
    this.showWcModal = true;
  }

  closeWcModal(): void {
    this.showWcModal = false;
    this.wcUri = '';
  }

  startWcPolling(sessionId: string): void {
    const poll = setInterval(async () => {
      const res = await fetch(`https://walletconnect-api.vercel.app/api/session?sessionId=${sessionId}`);

      if (res.status === 202) return; // Session en attente

      if (res.status === 200) {
        const session = await res.json();
        clearInterval(poll);

        const address = session?.namespaces?.['eip155']?.accounts?.[0]?.split(":")[2];
        if (!address) {
          alert("❌ Adresse introuvable dans la session !");
          return;
        }

        this.takerAddress = address;
        localStorage.setItem('wallet', address);
        localStorage.setItem('walletconnect_session', JSON.stringify(session));

        this.translate.get('WALLET_CONNECTED', { address }).subscribe(msg => console.log(msg));
        this.closeWcModal(); // Ferme la modal après succès
      }

      if (res.status === 404) {
        clearInterval(poll);
        alert('❌ Session expirée ou invalide.');
        this.closeWcModal();
      }
    }, 3000);
  }


  persistSession(): void {
    if (this.session) {
      localStorage.setItem('walletconnect_session', JSON.stringify(this.session));
    }
  }

  extractWalletAddress(): void {
    const address = this.session?.namespaces?.['eip155']?.accounts?.[0]?.split(':')[2];
    if (address) {
      this.takerAddress = address;
      this.isConnected = true;
      localStorage.setItem('wallet', address);
      console.log('✅ Wallet restauré / connecté :', address);

      // 👇 Ajout vital pour revalider l'abonnement
      this.checkSubscriptionStatus(address);
    }
  }


  restoreWalletSession(): void {
    const stored = localStorage.getItem('walletconnect_session');
    if (!stored) return;
    try {
      this.session = JSON.parse(stored);
      this.extractWalletAddress();
      if (this.takerAddress) {
        this.checkSubscriptionStatus(this.takerAddress); // ← AJOUTE CECI
      }
    } catch (e) {
      console.error('❌ Session JSON invalide', e);
    }
  }


  async pollSession() {
    const sessionId = localStorage.getItem("wc_session_id");
    if (!sessionId) return;

    try {
      const response = await fetch(`https://walletconnect-api.vercel.app/session.js?sessionId=${sessionId}`);
      if (!response.ok) return;

      const session = await response.json();
      const address = session?.namespaces?.eip155?.accounts?.[0]?.split(":")?.[2];

      if (address) {
        this.takerAddress = address;
        if (this.takerAddress) {
          localStorage.setItem('wallet', this.takerAddress);
        }
        this.translate.get('WALLET_CONNECTED', { address: this.takerAddress }).subscribe((msg) => console.log(msg));
      }
    } catch (error) {
      console.error("Erreur durant le polling WalletConnect:", error);
    }
  }

  disconnectWallet(forceKill: boolean = true): Promise<void> {
    return disconnectWallet.call(this, forceKill);
  }

  getFormattedAddress(address: string | null): string {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  }

  // Nouvelle méthode pour basculer entre les modes clair et sombre
  toggleTheme() {
    const body = document.body;
    if (body.classList.contains('light-mode')) {
      body.classList.remove('light-mode');
      body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      body.classList.remove('dark-mode');
      body.classList.add('light-mode');
      localStorage.setItem('theme', 'light');
    }
  }

  // Nouvelle méthode pour vérifier l'état du mode
  isDarkMode(): boolean {
    return document.body.classList.contains('dark-mode');
  }
  startCheckingAlerts() {
    this.alerts.forEach((alert, index) => {
      if (!alert.active || alert.triggered) return;

      if (alert.alertType === 'gasCost') {
        const intervalId = window.setInterval(() => this.checkGasAlert(alert), 10000);
        this.intervalMap.set(alert.id, intervalId);
      }

      if (alert.alertType === 'Prix du token') {
        const intervalId = window.setInterval(() => this.checkTokenPriceAlert(alert), 10000);
        this.intervalMap.set(alert.id, intervalId);
      }
    });

  }
  checkGasAlert(alert: Alert): void {
    const gasPrice = Number(this.currentSwapCost);
    const threshold = Number(String(alert.threshold).replace(',', '.'));
    const condition = alert.condition?.trim();

    // 🧱 Protection : si pas encore de gas price ou threshold valide
    if (!isFinite(gasPrice) || gasPrice === 0 || !isFinite(threshold)) return;

    // 🧱 Protection : condition mal définie
    if (condition !== 'Supérieur à' && condition !== 'Inférieur à') return;

    const conditionMet = condition === 'Supérieur à'
      ? gasPrice > threshold
      : gasPrice < threshold;

    // Option : reset si condition n'est plus vraie
    if (!conditionMet) {
      alert.triggered = false;
      return;
    }

    if (conditionMet && !alert.triggered) {
      alert.triggered = true;

      const sign = condition === 'Supérieur à' ? '>' : '<';

      this.showVisualAlert(
        `⛽ Alerte gas : ${gasPrice.toFixed(2)} Gwei ${sign} ${threshold.toFixed(2)} Gwei`
      );

      /*this.saveAlertsToLocalStorage();*/
    }

    console.log(`[CHECK] Gas actuel : ${gasPrice} Gwei | Condition : ${condition} | Seuil : ${threshold}`);
  }


  goToSwap(alert: Alert): void {
    this.router.navigate(['/'], {
      queryParams: {
        tokenIn: alert.tokenIn,
        tokenOut: alert.tokenOut,
        amountIn: alert.amountIn
      }
    });
  }

  reactivateAlert(alert: Alert): void {
    this.alertService.reactivateAlert(alert.id!).subscribe(success => {
      if (success) {
        alert.active = true;
        alert.triggered = false;
      }
    });
  }


  private nfCache = new Map<string, Intl.NumberFormat>();

  formatAmount(raw: string | number | bigint, decimals = 18): string {
    if (raw === '' || raw === null || raw === undefined) return '';
    if (!raw || raw === 0) return '0';
    const valueNum = Number(raw.toString());
    let min = 2, max = 2;
    const abs = Math.abs(valueNum);

    if (abs >= 100) max = 2;
    else if (abs >= 1) max = 4;
    else if (abs >= 0.01) max = 6;
    else { min = 4; max = Math.min(decimals, 8); }

    const key = `${min}-${max}`;
    if (!this.nfCache.has(key)) {
      this.nfCache.set(
        key,
        new Intl.NumberFormat('en-US', { minimumFractionDigits: min, maximumFractionDigits: max })
      );
    }
    return this.nfCache.get(key)!.format(valueNum);
  }

  onFormattedThresholdInput(event: Event): void {
    const val = parseFloat((event.target as HTMLInputElement).value);
    if (!isNaN(val)) {
      this.alert.threshold = val;
      this.userHasModifiedThreshold = true;
    }
  }



  onShareClick(): void {
    const baseUrl = window.location.origin + '/';
    const amountIn = this.quote?.formattedSellAmount;

    /*const shareUrl = `${baseUrl}?tokenIn=${tokenIn}&tokenOut=${tokenOut}&amountIn=${amountIn}`;*/
    const shareUrl = ``;

    if (navigator.share) {
      navigator.share({
        title: 'SmartSwap',
        text: "Vous avez partagez la tendance du marché merci",
        url: shareUrl,
      }).then(() => console.log('✅ Partagé avec succès'))
        .catch(err => console.error('❌ Erreur partage', err));
    } else {
      navigator.clipboard.writeText(shareUrl).then(() => {

      });
    }
  }



  checkTokenPriceAlert(alert: Alert): void {
    const tokenInAddress = this.availableTokens.find(t => t.symbol === alert.tokenIn)?.address;
    const tokenOutAddress = this.availableTokens.find(t => t.symbol === alert.tokenOut || t.symbol === 'USDC')?.address;
    const taker = this.takerAddress || localStorage.getItem('wallet') || '0x0000000000000000000000000000000000000000';

    if (!tokenInAddress || !tokenOutAddress) {
      console.error(`❌ Adresse token introuvable pour ${alert.tokenIn} ou ${alert.tokenOut}`);
      return;
    }

    this.swapApi.getQuoteForAlert(
      tokenInAddress,
      tokenOutAddress,
      '1000000000000000000', // simulate 1 token
      taker,
      alert.chainId
    ).subscribe({
      next: res => {
        const price = Number(res.price); // montant tokenOut reçu
        const threshold = Number(alert.threshold);
        const maxGasFee = Number(alert.maxGasFee ?? Infinity);

        // 🔢 Calcul des frais fiat
        const gasUsed = Number(res.estimatedGas ?? 21000);
        const gasPriceGwei = Number(res.gasPrice ?? 0) / 1e9;
        const ethUsd = Number(res.ethUsd ?? 0);
        const networkFeeFiat = gasUsed * gasPriceGwei * ethUsd;

        // ✅ Conditions
        const tokenConditionMet = alert.condition === 'Supérieur à'
          ? price > threshold
          : price < threshold;

        const gasConditionMet = networkFeeFiat < maxGasFee;

        const conditionMode = alert.conditionMode ?? 'AND';
        const conditionMet = conditionMode === 'AND'
          ? tokenConditionMet && gasConditionMet
          : tokenConditionMet || gasConditionMet;

        if (!alert.triggered && conditionMet) {
          alert.triggered = true;

          const messageParts: string[] = [];

          if (tokenConditionMet) {
            messageParts.push(
              `💸 ${alert.tokenIn} → ${alert.tokenOut} : reçu = ${price.toFixed(4)} ${alert.condition} ${threshold}`
            );
          }

          if (gasConditionMet) {
            messageParts.push(
              `⛽ frais estimés = ${networkFeeFiat.toFixed(2)} ${this.currencySymbol} < ${maxGasFee}`
            );
          }

          this.showVisualAlert(`✅ Alerte swap activée (${conditionMode}) :\n` + messageParts.join('\n'));
         /* this.saveAlertsToLocalStorage();*/
        }

        console.log(`[CHECK] ${alert.tokenIn} → ${alert.tokenOut} | Reçu: ${price} (seuil: ${threshold}) | Frais fiat: ${networkFeeFiat.toFixed(2)} ${this.currencySymbol} (max: ${maxGasFee}) | Mode: ${conditionMode}`);
      },
      error: err => {
        console.error(`❌ Erreur lors du check swap alert`, err);
      }
    });
  }








  showVisualAlert(message: string) {
    console.log('%c' + message, 'color: #8b5cf6; font-weight: bold; font-size: 14px');
    alert(message);
  }

  goToSubscription() {
    const wallet =
      this.takerAddress || localStorage.getItem('wallet');   // ➌ MODIFIÉ

    if (!wallet) {
      alert('Wallet manquant');
      return;
    }

    this.http.post<{ url: string }>(
      `${environment.backendUrl}/subscription/create-checkout-session`,
      { wallet },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'ngrok-skip-browser-warning': '1'
        })
      }
    ).subscribe({
      next: res => window.location.href = res.url,
      error: err => {
        console.error(err);
        alert('Erreur lors de la création du lien Stripe');
      }
    });
  }
  toggleExpand(alert: Alert): void {
    for (const a of this.mockAlerts) {
      if (a !== alert) a.isExpanded = false;
    }
    alert.isExpanded = !alert.isExpanded;
  }


  get isAmountZero(): boolean {
    return !this.alert?.amountIn || this.alert.amountIn === 0;
  }

  checkSubscriptionStatus(wallet: string) {
    this.http.get<{ active: boolean }>(`${environment.backendUrl}/subscription/is-subscribed/${wallet}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': '1'
      })
    })
      .subscribe(res => {
        this.subscriptionStatus = res.active ? 'active' : 'inactive';

        if (res.active) {
          localStorage.setItem('subscription', 'active');
          this.zone.run(() => {
            this.showActiveMessage = true;
            setTimeout(() => {
              this.showActiveMessage = false;
            }, 3000);
          });
        } else {
          localStorage.removeItem('subscription');
          // Optionnel : vider les alertes si abo inactive
          this.alerts = [];
        }

        // 🔁 Recharge les alertes, alertes déjà enrichies par backend
        this.alertService.getAlerts(this.takerAddress?.toLowerCase()!).subscribe(alerts => {
          console.log('📥 Alertes reçues depuis le backend:', alerts);

          alerts.forEach((alert, index) => {
            console.log(`🔎 Alerte #${index + 1} (ID: ${alert.id})`);
            console.log('   ➤ liveQuote:', alert.liveQuote);
            console.log('   ➤ currentGasFee:', alert.currentGasFee); // 👈 LOG ICI
            console.log('   ➤ alertType:', alert.alertType);
            console.log('   ➤ threshold:', alert.threshold);
          });
          this.alerts = alerts;
          this.isAlertsLoading = false;
          // Plus besoin de setInterval ici !
        });
      });
  }


  
}


 
